// This file is automatically generated by copy-versions.ts script

export const application = {version: '1.0.0-beta', revision: '', branch: ''};
export const dependencies = {nx: '7.8.1', schematics: '7.8.1', cli: '7.3.8', core: '7.2.15', mat: '7.3.7', rxjs: '6.4.0', svgjs: '2.7.1', ts: '3.2.4', webpack: '4.29.0'};
export const date = '2021-06-18T10:22:12.710Z';
